/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iframe_Remote_Display_Settings_Failed_ToastInputs */

const en_iframe_remote_display_settings_failed_toast = /** @type {(inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update display settings: ${i?.error}`)
};

const fr_iframe_remote_display_settings_failed_toast = /** @type {(inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de mise a jour des parametres d'affichage : ${i?.error}`)
};

const de_iframe_remote_display_settings_failed_toast = /** @type {(inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualisierung der Anzeigeeinstellungen fehlgeschlagen: ${i?.error}`)
};

const it_iframe_remote_display_settings_failed_toast = /** @type {(inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile aggiornare le impostazioni di visualizzazione: ${i?.error}`)
};

const ru_iframe_remote_display_settings_failed_toast = /** @type {(inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось обновить настройки дисплея: ${i?.error}`)
};

const es_iframe_remote_display_settings_failed_toast = /** @type {(inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar la configuración de pantalla: ${i?.error}`)
};

const zh_cn2_iframe_remote_display_settings_failed_toast = /** @type {(inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`显示设置更新失败：${i?.error}`)
};

const ja_iframe_remote_display_settings_failed_toast = /** @type {(inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`表示設定の更新に失敗しました: ${i?.error}`)
};

const hi_iframe_remote_display_settings_failed_toast = /** @type {(inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`डिस्प्ले सेटिंग्स को अपडेट करने में विफल: ${i?.error}`)
};

const pt_pt2_iframe_remote_display_settings_failed_toast = /** @type {(inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao atualizar as configurações de exibição: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to update display settings: {error}" |
*
* @param {Iframe_Remote_Display_Settings_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_display_settings_failed_toast = /** @type {((inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Display_Settings_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_display_settings_failed_toast(inputs)
	if (locale === "de") return de_iframe_remote_display_settings_failed_toast(inputs)
	if (locale === "it") return it_iframe_remote_display_settings_failed_toast(inputs)
	if (locale === "ru") return ru_iframe_remote_display_settings_failed_toast(inputs)
	if (locale === "es") return es_iframe_remote_display_settings_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_display_settings_failed_toast(inputs)
	if (locale === "ja") return ja_iframe_remote_display_settings_failed_toast(inputs)
	if (locale === "hi") return hi_iframe_remote_display_settings_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_display_settings_failed_toast(inputs)
	return en_iframe_remote_display_settings_failed_toast(inputs)
});